import { render, staticRenderFns } from "./RemessaLimite.vue?vue&type=template&id=e1e8524e&scoped=true&"
import script from "./RemessaLimite.vue?vue&type=script&lang=js&"
export * from "./RemessaLimite.vue?vue&type=script&lang=js&"
import style0 from "./RemessaLimite.vue?vue&type=style&index=0&id=e1e8524e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e8524e",
  null
  
)

export default component.exports